import React, { useState } from "react";
import {
  Box,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import TabVisual from "../visuals/TabVisual";

const ColorlibStepIconRoot = styled("div")(() => ({
  backgroundColor: "#B1D238",
  zIndex: 1,
  color: "#fff",
  width: 12,
  height: 12,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
}));
const Container = styled(Stack)(() => ({
  width: "26px",
  height: "24px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "35px",
  backgroundColor: " rgba(177, 210, 56, 0.2)",
}));
const Scheduler = () => {
  const [value, setValue] = useState("Day 1");

  const options = [
    {
      label: "Day 1",
      value: "Day 1",
      items: [
        {
          id: 1,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 2,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 3,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 4,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
      ],
    },
    {
      label: "Day 2",
      value: "Day 2",
      items: [
        {
          id: 1,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 2,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 3,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
      ],
    },
    {
      label: "Day 3",
      value: "Day 3",
      items: [
        {
          id: 1,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
        {
          id: 2,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
      ],
    },
    {
      label: "Day 4",
      value: "Day 4",
      items: [
        {
          id: 1,
          time: "08:00-10:00",
          details: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        },
      ],
    },
  ];

  let content = options.find((i) => i.value === value)?.items;

  const ColorlibStepIcon = () => {
    return (
      <Container>
        <ColorlibStepIconRoot></ColorlibStepIconRoot>
      </Container>
    );
  };
  const Briefing = (steps: any) => {
    return (
      <Box>
        <Stepper orientation="vertical">
          {steps &&
            steps.steps.map((step: any) => (
              <Step key={step.id} active={true}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  <Typography fontWeight={500}> {step.time}</Typography>
                </StepLabel>
                <StepContent>
                  <Typography>{step.details}</Typography>
                </StepContent>
              </Step>
            ))}
        </Stepper>
      </Box>
    );
  };

  const handleAction = (value: any) => {
    setValue(value);
  };
  return (
    <Stack>
      <Stack spacing={1.5} direction="row" pb={2}>
        {options &&
          options.map((item) => {
            return (
              <TabVisual
                label={item.label}
                onClick={() => handleAction(item.label)}
              />
            );
          })}
      </Stack>
      <Briefing steps={content} />
    </Stack>
  );
};
export default Scheduler;
